import { Component, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { ResourceNotFoundService } from '../../services/resource-not-found.service';

@Component({
  selector: 'app-resource-not-found-dialog',
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
  template: `
    <p-dialog
      [header]="'errors.resource_not_found_title' | translate"
      [visible]="visible"
      [modal]="true"
      [closable]="false"
      [closeOnEscape]="false"
      [dismissableMask]="false"
      appendTo="body"
      [baseZIndex]="1100"
      [style]="{ width: '28rem' }"
    >
      <p class="text-center">{{ 'errors.resource_not_found' | translate }}</p>
      <div class="flex justify-center gap-2 mt-4">
        <p-button
          [label]="'common.close' | translate"
          severity="secondary"
          styleClass="btn-menu-exit"
          outlined
          (onClick)="onClose()"
        />
      </div>
    </p-dialog>
  `,
})
export class ResourceNotFoundDialogComponent {
  private readonly resourceNotFoundService = inject(ResourceNotFoundService);

  visible = false;

  constructor() {
    effect(() => {
      this.visible = this.resourceNotFoundService.visible();
    });
  }

  onClose(): void {
    this.visible = false;
    this.resourceNotFoundService.closeAndRedirect();
  }
}
